export default class BulkActions {
	constructor() {
		this.init();
	}

	init() {
		document.querySelectorAll('input[type="checkbox"][data-provide="bulkActions"]:not([data-datatable-init="1"])').forEach(function (checkbox, key) {
			checkbox.setAttribute('data-datatable-init', "1");

			let gridTable = checkbox.closest('table').closest('div.dataTables_scroll');

			if (!gridTable) {
				return;
			}

			if (checkbox.getAttribute('data-action-type') === 'bulkCheckbox') {
				checkbox.addEventListener('change', (e) => {
					let checked = e.currentTarget.checked;

					gridTable.querySelectorAll('input[type="checkbox"][data-provide="bulkActions"][data-action-type="bulkCheckboxItem"]').forEach(function (checkboxItem, key) {
						checkboxItem.checked = checked;
					});
				});
			}

			checkbox.addEventListener('change', (e) => {
				let idDatatables = checkbox.getAttribute('data-datatables-id');
				let bulkActions = document.querySelector('select[data-datatables-id="' + idDatatables + '"][data-provide="select"]');
				let checked = e.currentTarget.checked;

				if (bulkActions && checked && bulkActions.hasAttribute('disabled')) {
					bulkActions.removeAttribute('disabled');
				} else if (bulkActions && !checked) {
					let totalChecked = gridTable.querySelectorAll('input[type="checkbox"][data-provide="bulkActions"]:checked').length;

					if (!totalChecked && !bulkActions.hasAttribute('disabled')) {
						bulkActions.setAttribute('disabled', 'true');
					}
				}
			});

		});

	}
}
